import { SVGProps } from "react";

const PaperClipIcon = ({ fill, ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_728_1723)">
        <path
          d="M14.8708 6.44979C14.626 6.20635 14.2303 6.20744 13.9869 6.45216L6.47356 14.0061C5.4988 14.9809 3.91565 14.9809 2.93907 14.0048C1.96323 13.0284 1.96323 11.4453 2.93919 10.4693L10.6749 2.69299C11.2835 2.08445 12.2729 2.08445 12.8832 2.69431C13.4933 3.30446 13.4933 4.29375 12.883 4.90408L6.47473 11.3123C6.47432 11.3127 6.47397 11.3132 6.47356 11.3136C6.22942 11.5564 5.83487 11.5561 5.59123 11.3124C5.34718 11.0684 5.34718 10.6729 5.59123 10.4288L8.68447 7.33492C8.92852 7.09082 8.92849 6.69507 8.68438 6.45102C8.44027 6.20697 8.04452 6.207 7.80047 6.4511L4.70727 9.54493C3.97509 10.2771 3.97509 11.4641 4.70732 12.1963C5.43953 12.9285 6.62655 12.9285 7.35878 12.1963C7.35963 12.1955 7.36031 12.1946 7.36113 12.1937L13.7669 5.78792C14.8654 4.68944 14.8654 2.90868 13.7669 1.8102C12.6683 0.712357 10.8876 0.712357 9.78981 1.8102L2.05411 9.58659C0.591163 11.0495 0.591163 13.424 2.05516 14.8887C3.52013 16.3529 5.89458 16.3529 7.35867 14.8888L14.8732 7.33369C15.1166 7.08894 15.1155 6.69322 14.8708 6.44979Z"
          fill={fill ?? "#1F1F1F"}
        />
      </g>
      <defs>
        <clipPath id="clip0_728_1723">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0.5 0.986816)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PaperClipIcon;
